export default __webpack_public_path__ + "2329a94b75bce079fd66ba09cb811295.png";